// extracted by mini-css-extract-plugin
export default {"icon":"AssessmentActions_icon__S3pbo","trigger":"AssessmentActions_trigger__XbmEd","activeTrigger":"AssessmentActions_activeTrigger__211wL"};